import { useState } from 'react';
import { formatDate } from '../../../lib/date';
import request from '../../../lib/request';
import Calendar from '../../../components/calendar';

const StartPopup = ({
  dialogRef,
  closeDialog,
  selectedChallenge,
  user,
  openPayDialog,
  closeChallengePopup,
  goToDashboardChallenge,
}) => {
  const [scheduledDate, setScheduledDate] = useState('');
  const [openScheduler, setOpenScheduler] = useState(false);

  const enrollUser = async () => {
    try {
      if (
        selectedChallenge.premium &&
        !user.activated &&
        !user.programRegistered
      ) {
        openPayDialog();
        return;
      }

      if (!window.confirm('Are you sure you want to enroll?')) {
        return;
      }

      const payload = {
        challengeId: selectedChallenge.id,
      };

      const url = '/challenge/schedule';

      if (scheduledDate) {
        payload.startDate = new Date(scheduledDate).toISOString();
      } else {
        payload.startDate = new Date().toISOString();
      }

      const { result } = await request.post(url, payload);
      if (result) {
        handleClose();
        closeChallengePopup();
        goToDashboardChallenge();
      }
      return result;
    } catch (err) {
      console.log(err);
    }
  };

  const handleClose = () => {
    setOpenScheduler(false);
    setScheduledDate('');
    closeDialog();
  };

  return (
    <dialog
      ref={dialogRef}
      className='bg-tertiary rounded-xl p-4 w-full max-w-[320px]'
    >
      {selectedChallenge && (
        <div>
          <div className='flex items-center justify-between text-white mb-4'>
            <h1 className='font-bold text-xs'>{selectedChallenge.title}</h1>
            <button
              onClick={handleClose}
              className=' text-xl'
            >
              🅧
            </button>
          </div>
          {openScheduler ? (
            <div>
              <div className='text-white mb-4 text-lg font-bold'>
                When do you want to start?
              </div>
              <div className='mb-4'>
                <Calendar
                  selectedDate={scheduledDate}
                  selectDate={(date) => setScheduledDate(date)}
                />
              </div>
              <div className='flex items-center gap-2'>
                <button
                  className='capitalize rounded-xl px-4 py-2 bg-secondary/30 text-white'
                  onClick={() => setOpenScheduler(false)}
                >
                  Cancel
                </button>
                <button
                  className={`capitalize rounded-xl px-4 py-2 bg-black text-white flex-1 ${
                    new Date(scheduledDate) <
                    new Date(`${formatDate(new Date())}T00:00:00`)
                      ? 'opacity-50'
                      : ''
                  }`}
                  onClick={enrollUser}
                  disabled={
                    !scheduledDate ||
                    new Date(scheduledDate) <
                      new Date(`${formatDate(new Date())}T00:00:00`)
                  }
                >
                  done
                </button>
              </div>
            </div>
          ) : (
            <div className='flex flex-col gap-2'>
              <button
                className={`capitalize rounded-xl px-4 py-2 bg-black text-white `}
                onClick={enrollUser}
              >
                start today
              </button>
              <button
                className={`capitalize rounded-xl px-4 py-2 text-white bg-secondary/50 `}
                onClick={() => setOpenScheduler(true)}
              >
                schedule for later
              </button>
            </div>
          )}
        </div>
      )}
    </dialog>
  );
};

export default StartPopup;
